import store from '@/store';

export default {
  install(Vue, options) {
    Vue.prototype.$hasPermissionByRouteName = function(routeName) {
      const perms = store.getters.perms;
      for (const auth of perms) {
        if (auth.url === routeName
          || routeName.indexOf(auth.url+'-') === 0) {//子页面也允许
          return true;
        }
      }
      return false;
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/permission/index.js